export enum TestId {
  APP_TITLE = 'APP_TITLE',
  LOADING_SPINNER = 'LOADING_SPINNER',

  // Navigation
  BOTTOM_NAVIGATION_MARKETPLACE = 'BOTTOM_NAVIGATION_MARKETPLACE',
  BOTTOM_NAVIGATION_CHECKOUT = 'BOTTOM_NAVIGATION_CHECKOUT',
  BOTTOM_NAVIGATION_PAST_ORDERS = 'BOTTOM_NAVIGATION_PAST_ORDERS',

  // Marketplace
  MARKETPLACE_PIZZA_CARD = 'MARKETPLACE_PIZZA_CARD',
  MARKETPLACE_CART_BUTTON = 'MARKETPLACE_CART_BUTTON',
  MARKETPLACE_NO_OF_ORDER_ITEMS = 'MARKETPLACE_NO_OF_ORDER_ITEMS',
  MARKETPLACE_ADD_PIZZA_TO_CART = 'MARKETPLACE_ADD_PIZZA_TO_CART',

  // Checkout
  CHECKOUT_TOTAL_PRICE = 'CHECKOUT_TOTAL_PRICE',
  CHECKOUT_PLACE_ORDER_BUTTON = 'CHECKOUT_PLACE_ORDER_BUTTON',
  CHECKOUT_EMPTY_CART_MESSAGE = 'CHECKOUT_EMPTY_CART_MESSAGE',
  CHECKOUT_ORDER_ITEM = 'CHECKOUT_ORDER_ITEM',
  CHECKOUT_REMOVE_ORDER_ITEM = 'CHECKOUT_REMOVE_ORDER_ITEM',
  CHECKOUT_FORM_FIRST_NAME = 'CHECKOUT_FORM_FIRST_NAME',
  CHECKOUT_FORM_LAST_NAME = 'CHECKOUT_FORM_LAST_NAME',
  CHECKOUT_FORM_EMAIL = 'CHECKOUT_FORM_EMAIL',

  // Past orders
  PAST_ORDERS_ORDER = 'PAST_ORDERS_ORDER',
  PAST_ORDERS_NO_ORDERS_MESSAGE = 'PAST_ORDERS_NO_ORDERS_MESSAGE',
}
